<template>
	<select
		ref="input"
		:name="name"
		v-bind="attributes"
		:value="currentValue"
		@input="handleInput"
		@change="handleChange"
		@focus="handleFocus"
		@blur="handleBlur"
        
	>
        <option
            v-for="(option, key) in selectOptions"
            :key="key"
            :value="key"
        >
            {{option}}
        </option>
    </select>
</template>

<script>
import basefield from '../../mixins/basefield'

export default {
	name: 'formit-select',
	mixins: [basefield],
}
</script>



// WEBPACK FOOTER //
// node_modules/vue-formit-fields/src/components/select/select.vue